import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { UsuarioSistema } from 'src/app/core/usuario-sistema';
import { DataUtilService } from '../../../services/commons/data-util.service';

@Component({
  selector: 'dados-usuario',
  templateUrl: './dados-usuario.component.html',
  styleUrls: ['./dados-usuario.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DadosUsuarioComponent implements OnInit {

  @Input() usuarioSistema: UsuarioSistema;
  @Input() isAtualizar: boolean;

  hide = true;

  constructor(private dataUtilService: DataUtilService) {

  }

  ngOnInit() {
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

}
